<template>
  <section v-if="reviews.length" class="poi-reviews">
    <article v-for="(review, index) in shownReviews" :key="index" class="poi-review">
      <header class="poi-review__head">
        <strong>{{ review.author }}</strong>
        <span v-if="review.rating" class="poi-review__stars">
          <span v-for="n in filledStarCount(review.rating)" :key="`r${index}-${n}`" class="material-icons">star</span>
        </span>
      </header>
      <p v-if="review.when" class="poi-review__when">{{ review.when }}</p>
      <OverviewClampedText :text="review.text" text-class="poi-review__text" />
    </article>
    <!-- The sheet ends with its reviews, so the rest open in place (OverviewSectionPreview). -->
    <button
      v-if="preview.action === 'show_more' || preview.action === 'show_less'"
      type="button"
      class="overview-preview-toggle"
      data-testid="poi-reviews-toggle"
      :aria-expanded="String(expanded)"
      @click="expanded = !expanded"
    >{{ preview.action === 'show_less' ? $t('overview_preview.show_less') : $t('overview_preview.show_more') }}</button>
  </section>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import OverviewClampedText from '../../utils/shared_components/OverviewClampedText.vue'
import { overviewSectionPreview } from '../../utils/overviewSectionPreview'
import type { SerpReview } from '../../utils/helpers/poiSheet'
import { filledStarCount } from './helpers/starRating'

/** The Google reviews at the foot of the POI sheet: the first few, each body capped. */
const props = defineProps<{ reviews: SerpReview[] }>()

const expanded = ref(false)
// Never open by default, and closed again for every new place.
watch(() => props.reviews, () => { expanded.value = false })

const preview = computed(() => overviewSectionPreview('poi_reviews', props.reviews.length, expanded.value))
const shownReviews = computed(() => props.reviews.slice(0, preview.value.shown))
</script>
